"use client";
import { useEffect, useState } from "react";

export const RECOVERY_KEY = "err_recover";
export const CACHE_BUST_PARAM = "_r";

type Recovery = "reload" | "home" | null;

export const useErrorAutoReload = (): boolean => {
  const [action] = useState<Recovery>(() => {
    if (typeof window === "undefined") return null;
    try {
      const attempts = Number(window.sessionStorage.getItem(RECOVERY_KEY) ?? "0");
      if (attempts === 0) {
        window.sessionStorage.setItem(RECOVERY_KEY, "1");
        return "reload";
      }
      if (attempts === 1 && window.location.pathname !== "/") {
        window.sessionStorage.setItem(RECOVERY_KEY, "2");
        return "home";
      }
      return null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (!action) return;
    const timer = window.setTimeout(() => {
      if (action === "reload") {
        const url = new URL(window.location.href);
        url.searchParams.set(CACHE_BUST_PARAM, Date.now().toString(36));
        window.location.replace(url.toString());
      } else {
        window.location.replace("/");
      }
    }, 150);
    return () => window.clearTimeout(timer);
  }, [action]);

  return action !== null;
};

export default useErrorAutoReload;